module.exports = __webpack_public_path__ + "static/Assemble-54224eb1b72c5b42fd60d37b4705632d.svg";